import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import { scrollToElement } from '../utils';
import styles from './ContactInfo.module.css';
import { locationIcon, mailIcon } from '../utils/icons';

const onClick = () => scrollToElement('#kontakt');

const ContactInfo = ({ company: { addressFields, mail, phone }, className, vertical }) => {
  return (
    <div className={`${styles.contact} ${className}`} style={{ flexDirection: vertical ? 'column' : undefined }}>
      <List dense disablePadding className={styles.address}>
        <ListItem disableGutters>
          <Avatar className={styles.avatar}>{locationIcon}</Avatar>
          <ListItemText classes={{ secondary: styles.secondary }} secondary={`${addressFields.join('\n')}`} onClick={onClick} />
        </ListItem>
      </List>
      <List dense disablePadding>
        <ListItem disableGutters>
          <Avatar className={styles.avatar}>{mailIcon}</Avatar>
          <ListItemText
            classes={{ secondary: styles.secondary }}
            secondary={
              <span className={styles.contacts}>
                <a href={`tel:${phone.replace(/\D/g, '').replace('0', '')}`}>{phone}</a>
                <a href={`mailto:${mail.replace(/\D/g, '')}`}>{mail}</a>
              </span>
            }
          />
        </ListItem>
      </List>
    </div>
  );
};

ContactInfo.propTypes = {
  company: PropTypes.shape({
    addressFields: PropTypes.arrayOf(PropTypes.string),
    mail: PropTypes.string,
    phone: PropTypes.string,
  }).isRequired,
  className: PropTypes.string.isRequired,
};

ContactInfo.defaultProps = {
  className: '',
};

export default ContactInfo;



// WEBPACK FOOTER //
// ./src/components/ContactInfo.js